function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.31 13.94a3.38 3.38 0 100-6.76 3.38 3.38 0 000 6.76zm5.2-5.63c-.55 0-1-.45-1-1s.44-1 1-1h.01c.55 0 1 .45 1 1-.01.55-.46 1-1.01 1zm-4.45 10.25c-.19 0-.38-.07-.53-.22a.754.754 0 010-1.06l3-3c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-3 3c-.14.15-.34.22-.53.22z"
})));